module.exports = __webpack_public_path__ + "img/logo.f4604326.png";